import React from 'react';

const SvgClockFill = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M12 2a10 10 0 100 20 10 10 0 000-20zm4.29 15.71L11 12.41V5h2v6.59l4.71 4.7-1.42 1.42z" />
  </svg>
);

export default SvgClockFill;
